var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadCircled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EDF0F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4095:5573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.672 13.6H18.4V9.6C18.4 9.16 18.04 8.8 17.6 8.8H14.4C13.96 8.8 13.6 9.16 13.6 9.6V13.6H12.328C11.616 13.6 11.256 14.464 11.76 14.968L15.432 18.64C15.744 18.952 16.248 18.952 16.56 18.64L20.232 14.968C20.736 14.464 20.384 13.6 19.672 13.6ZM10.4 21.6C10.4 22.04 10.76 22.4 11.2 22.4H20.8C21.24 22.4 21.6 22.04 21.6 21.6C21.6 21.16 21.24 20.8 20.8 20.8H11.2C10.76 20.8 10.4 21.16 10.4 21.6Z",
    fill: "#646471"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4095:5573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(6.40002 6.4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCircled);
export default __webpack_public_path__ + "static/media/download-circled.a89f3b6d.svg";
export { ForwardRef as ReactComponent };